<style scoped>
.item-container {
  max-width: 20rem;
  margin: 0;
}
.item {
  margin: 0.5rem;
  border: solid #7a766c 0.5px;
  max-width: 25rem;
  border-radius: 1rem;
  color: #fac020;
  padding-left: 1rem;
}
.item-sub {
  margin: 0 0 0 1rem;
}
.icon {
  color: #a9c468;
  margin: 0.2rem;
  z-index: 999;
}
</style>
<template>
  <div
    v-if="shown"
    :class="
      `v-treeview-node v-treeview-node--click ${
        hasChildren ? '' : 'v-treeview-node--leaf'
      }`
    "
  >
    <div class="v-treeview-node__root item">
      <i
        v-if="hasChildren"
        role="button"
        class="
          v-icon
          notranslate
          v-treeview-node__toggle
          v-icon--link
          mdi mdi-menu-down
          icon
        "
        :class="{
          'v-treeview-node__toggle--open': open
        }"
        @click="onToggleOpen()"
      />
      <slot
        name="prepend"
        v-bind="{ item: value, open }"
        @click="onToggleOpen()"
      />
      <div class="v-treeview-node__label" @click="onToggleOpen()">
        <slot name="label" v-bind="{ item: value, open }">
          {{ value.name }}
        </slot>
      </div>
      <slot name="append" v-bind="{ item: value }" />
      <i
        role="button"
        class="v-icon v-icon--link mdi mdi-open-in-new icon"
        @click="onExpand(value.id)"
      />
      <i
        role="button"
        class="v-icon v-icon--link mdi mdi-plus-box-outline icon"
        @click="addChildNode(value)"
      />
      <i
        role="button"
        class="v-icon v-icon--link mdi mdi-delete-outline icon"
        @click="removeNode(value)"
      />
    </div>
    <div
      v-if="open"
      class="v-treeview-node__children v-treeview-node__children__draggable"
    >
      <draggable
        :group="group"
        :value="value.children"
        ghost-class="ghost"
        @input="updateValue"
      >
        <menu-items-draggable-node
          v-for="child in value.children"
          :group="group"
          :key="child.id"
          :value="child"
          @input="updateChildValue"
          @update="onNodeUpdate"
          :ref="'childRef' + child.id"
          @notifyParent="handleChildResult"
          :show="showChildren"
        >
          <template v-slot:prepend="{ item, open }">
            <slot name="prepend" v-bind="{ item, open }" />
          </template>
          <template v-slot:append="{ item }">
            <slot name="append" v-bind="{ item }" />
          </template>
        </menu-items-draggable-node>
      </draggable>
    </div>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import { EventBus } from '../../helpers/Events'

export default {
  name: 'menu-items-draggable-node',
  components: {
    Draggable
  },
  props: {
    value: {
      type: Object,
      default: new Object()
    },
    root: {
      type: Boolean,
      default: false
    },
    group: {
      type: String,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: false,
      localValue: { ...this.value },
      defaultMenuItem: {
        name: 'New Menu Item',
        parentMenuItemId: 0,
        clientId: 0,
        order: 0,
        properties: '{}'
      },
      newMenuItemsCounter: 0,
      shown: true,
      childrenResultsCounter: 0,
      foundInChild: false,
      selfResult: false,
      showChildren: false
    }
  },
  mounted: function() {},
  created: function() {
    for (let openMenuItemId of localStorage.menuItemsTreeState.split(',')) {
      if (openMenuItemId == this.value.id) {
        this.open = true
        break
      }
    }
  },
  computed: {
    hasChildren() {
      return this.value.children != null && this.value.children.length > 0
    }
  },
  watch: {
    value(value) {
      this.localValue = { ...value }
    },
    // force show from parent on search
    show(value) {
      if (value) {
        this.shown = true
      }
    }
  },
  methods: {
    onToggleOpen() {
      let localCopy = localStorage.menuItemsTreeState
        ? localStorage.menuItemsTreeState.split(',')
        : []
      if (this.open) {
        for (let i = 0; i < localCopy.length; i++) {
          if (localCopy[i] == this.value.id) {
            localCopy.splice(i, 1)
            break
          }
        }
        this.open = false
      } else {
        localCopy.push(this.localValue.id)
        this.open = true
      }
      localStorage.menuItemsTreeState = localCopy.join()
    },
    updateValue(value) {
      this.localValue.children = [...value]
      this.$emit('input', this.localValue)
    },
    updateChildValue(value) {
      const index = this.localValue.children.findIndex(c => c.id === value.id)
      this.$set(this.localValue.children, index, value)
      this.$emit('input', this.localValue)
    },
    onExpand(itemId) {
      this.$router.push('/menu-item/' + itemId).catch(err => {})
    },
    addChildNode(item) {
      this.newMenuItemsCounter++
      this.defaultMenuItem.name =
        this.defaultMenuItem.name + ' ' + this.newMenuItemsCounter
      this.defaultMenuItem.parentMenuItemId = item.id
      this.defaultMenuItem.clientId = this.$store.state.ClientAppStore.selectedApp.id
      this.defaultMenuItem.order = item.children.length + +1
      this.$store
        .dispatch('MenuItemsStore/createMenuItem', this.defaultMenuItem)
        .then(res => {
          this.$emit('update')
          this.defaultMenuItem.name = 'New Menu Item'
          this.open = true
        })
    },
    removeNode(item) {
      this.$store.dispatch('MenuItemsStore/deleteMenuItem', item).then(res => {
        this.$emit('update', item)
      })
    },
    onNodeUpdate(value) {
      this.$emit('update', value)
    },
    onSearch: async function(searchTerm) {
      // reset values
      this.childrenResultsCounter = 0
      this.showChildren = false
      this.foundInChild = false
      this.childrenResults = []
      this.open = true
      this.shown = true
      // HACK - to make sure refs are instantiated again
      await setTimeout(() => {}, 0)

      // search result
      this.selfResult = new RegExp(searchTerm, 'i').test(this.localValue.name)
      // if you don't have children - send your result to parent
      if (!this.hasChildren) {
        this.$emit('notifyParent', this.localValue.id, this.selfResult)
        if (this.selfResult) {
          this.shown = true
        } else {
          // don't hide root menu item
          if (this.localValue.parentMenuItemId !== 0) this.shown = false
          this.open = false
        }
      }
      // else - call search in children to collect the results
      else {
        // show children again to get refs
        this.showChildren = true
        // call search in children
        for (let index = 0; index < this.localValue.children.length; index++) {
          const child = this.localValue.children[index]
          let refName = 'childRef' + child.id
          let childRef = this.$refs[refName][0]
          childRef.onSearch(searchTerm)
        }
      }
    },
    handleChildResult(childId, childResult) {
      const self = this
      self.childrenResultsCounter++
      if (childResult) self.foundInChild = true

      // if last child is checked, check results and notify parent
      if (self.childrenResultsCounter === self.localValue.children.length) {
        this.$emit(
          'notifyParent',
          this.localValue.id,
          self.selfResult || self.foundInChild
        )
        if (self.selfResult || self.foundInChild) {
          this.shown = true
        } else {
          // don't hide root menu item
          if (this.localValue.parentMenuItemId !== 0) {
            this.open = false
            this.shown = false
          }
        }
      }
    }
  }
}
</script>
